
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

let resultContainerElement;

class ResultBar extends Component {

  constructor(props) {
    super(props);
    this.windowScrollHandler = this.windowScrollHandler.bind(this);
    this.checkResultBarVisibility = this.checkResultBarVisibility.bind(this);

    this.state = {
      visible: false,
      animateClass: ''
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.windowScrollHandler, false);
    resultContainerElement = document.getElementById('results-container');
    this.checkResultBarVisibility();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.windowScrollHandler, false);
    resultContainerElement = null;
  }

  windowScrollHandler(e) {
    this.checkResultBarVisibility();
  }

  checkResultBarVisibility() {
    if(!resultContainerElement) {
      return;
    }

    let docViewBottom = (window.scrollY ? window.scrollY : document.documentElement.scrollTop) + window.innerHeight;
    let elemTop = resultContainerElement.offsetTop;

    if((elemTop + 100) > docViewBottom) {
      this.setState({visible: true});
    } else {
      if(this.state.visible) {
        this.setState({visible: false});
      }
    }
  }

  render() {
    const {
      results
    } = this.props;

    let items;
    if(results) {
      items = results.map( (item, index) => {
        return (
          <div key={index} className={"item-container"}>
            <div className="topic">{item.topic}</div>
            <div className="value">{item.value} {item.unit}</div>
          </div>
        );
      });
    }

    return (
      <div className={'result-bar animated ' + (this.state.visible ? ' visible resultBarUpAnimation' : ' hidden')} >
        {items}
      </div>
    );
  }
}

ResultBar.propTypes = {

  results: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      // add: () => dispatch(addSection()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResultBar);
